"use client"

import type { PointerEvent, ReactNode } from "react"

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"

import { CloseButton } from "@/components/ui/close-button"
import { useHistoryDismiss } from "@/lib/hooks/use-history-dismiss"

interface LightboxProps {
  open: boolean
  onClose: () => void
  label: string
  closeLabel?: string
  toolbar?: ReactNode
  footer?: ReactNode
  children: ReactNode
}

export const Lightbox = ({ open, onClose, label, closeLabel, toolbar, footer, children }: LightboxProps) => {
  useHistoryDismiss(open, onClose)

  const dismissOnSelf = (event: PointerEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} aria-label={label}>
      <DialogBackdrop transition className="bg-nelo-black-soft z-modal-backdrop ease-productive duration-moderate fixed inset-0 transition data-closed:opacity-0" />
      <DialogPanel
        transition
        className="z-modal ease-expressive duration-moderate fixed inset-0 flex flex-col transition data-closed:scale-98 data-closed:opacity-0 motion-reduce:transition-none motion-reduce:data-closed:scale-100"
      >
        <div onPointerDown={dismissOnSelf} className="pt-safe-offset-300 flex shrink-0 items-center justify-between gap-300 p-300">
          {toolbar}
          <CloseButton onClick={onClose} aria-label={closeLabel} className="text-on-scrim-muted hover:text-on-scrim ml-auto size-11" />
        </div>
        <div onPointerDown={dismissOnSelf} className="relative min-h-0 flex-1">
          {children}
        </div>
        {footer && (
          <div onPointerDown={dismissOnSelf} className="pb-safe-offset-300 shrink-0 p-300">
            {footer}
          </div>
        )}
      </DialogPanel>
    </Dialog>
  )
}
